import Parse from 'parse'

const state = {
  init: false,
  quiz: null,
  quizzes: [],
  hints: []
}

const mutations = {
  setInit (state) {
    state.init = true
  },

  setQuiz (state, quiz) {
    state.quiz = quiz
  },

  initQuizzes (state) {
    state.quizzes = []
    for (let i = 0; i < 13; i++) {
      state.quizzes.push({
        spades: null,
        hearts: null,
        diamonds: null,
        clubs: null
      })
    }
  },

  setQuizzes (state, quizzes) {
    quizzes.map((quiz) => {
      const card = quiz.get('card')
      const suit = card.get('suit')
      state.quizzes[card.get('number') - 1][suit.get('name')] = quiz
    })
  },

  setHints (state, hints) {
    state.hints = hints.map(h => h.get('hint'))
  }
}

const actions = {
  async checkPoint ({ commit, dispatch, rootGetters }) {
    commit('setQuiz', null)
    await dispatch('gps/setPosition', null, { root: true })
    const geoPoint = rootGetters['gps/point']
    //console.log(geoPoint)
    //geoPoint.latitude = 35.6925765
    //geoPoint.longitude= 139.6911872
    const result = await Parse.Cloud.run('quizPointCheck', {
      geoPoint: geoPoint
    })

    if (result.status === 'pointCheckNotAllowed') {
      await dispatch('event/fetchPlaying', null, { root: true })
      return result.status
    }
    commit('setQuiz', result.quiz)
  },

  async fetchFoundQuizzes ({ commit }) {
    const quizFounds = await Parse.Cloud.run('quizFound')
    commit('setQuizzes', quizFounds.map(q => q.get('quiz')))
  },

  async fetchHints ({ commit }, quiz) {
    const foundQuiz = await Parse.Cloud.run('getHints', {
      quizId: quiz.id
    })
    commit('setHints', foundQuiz)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
